'use strict';

/* jshint -W098 */
angular.module('mean.projects').controller('ProjectTradeManagerController', ['$scope', '$rootScope', 'Global', 'MeanUser', 'Users', '$filter', 'Projects', 'ProjectTasks', '$timeout', 'ProjectBids', 'Builders', 'ProjectHours', 'ProjectMaterials', 'ProjectEquipments', 'userService', 'Trades', 'contactService', 'tradeCodeService', 'aceUtils',
  function($scope, $rootScope, Global, MeanUser, Users, $filter, Projects, ProjectTasks, $timeout, ProjectBids, Builders, ProjectHours, ProjectMaterials, ProjectEquipments, userService, Trades, contactService, tradeCodeService, aceUtils) {
    $scope.global = Global;

    $scope.package = {
      name: 'projectHome'
    };

    $scope.is_admin = false;
    $scope.codes = [];

    $scope.summaryTable = {};

    Chart.defaults.global.responsive = true;

    Chart.defaults.global.scaleLabel = function (label) {
        if($scope.selectedGraph === 'Labor Hours') {
            return label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return '$ ' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    };

    Chart.defaults.global.multiTooltipTemplate = function (label) {
        var tmp = $filter('filter')($scope.codes, {'name': label.label}, true)[0];
        if(tmp)
          label.label = label.label + ' ' + tmp.task_name;
        if($scope.selectedGraph === 'Labor Hours') {
            return label.datasetLabel + ': ' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return label.datasetLabel + ': $ ' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }; 

    $scope.spreadsheets = [];
    $scope.spreadsheets.phases = [];
    $scope.spreadsheets.phases.lots = [];
    $scope.spreadsheets.phases.lots.data = [];

    $scope.colors = ['#97BBCD','#46BFBD','#7FFD1F','#68F000'];

    $scope.bid_hours_labels = ["Total Hours", "Not Complete", "Delayed", "Completed", "No Valid Project or Tasks"];
  	$scope.bid_hours_data = [];
  	$scope.line_chart_labels = [];
  	$scope.line_chart_series = [];
  	$scope.line_chart_data = [
    	[],
    	[]
  	];

  	$scope.onClick = function (points, evt) {
    	console.log(points, evt);
  	};

  	$scope.graphs = ['Labor Hours', 'Labor Costs', 'Total Costs', 'Materials', 'Equipment'];
    $scope.dataType = ['Cumulative', 'Task'];
  	$scope.selectedGraph = 'Labor Hours';
  	$scope.selectedItem = {};
    $scope.selectedDataType = 'Cumulative';
    $scope.tasks = [];
    $scope.builders = [];
    $scope.projects = [];
    $scope.phases = [];
    $scope.lots = [];
    $scope.trades = [];
    $scope.companyFactors = [];
    $scope.user = MeanUser.user;
    $scope.wait = true;

    $rootScope.$on('loggedin', function() {
        $scope.user = MeanUser.user;
        $scope.init();
    });

    $scope.buildSummaryTable = function() {
        console.log($scope.spreadsheets);

        $scope.summaryTable.bid_total = 0;
        $scope.summaryTable.bid_labor = 0;
        $scope.summaryTable.bid_direct_labor = 0;
        $scope.summaryTable.bid_hours_allowed = 0;
        $scope.summaryTable.bid_materials = 0;
        $scope.summaryTable.bid_equipment = 0;
        $scope.summaryTable.actual_total = 0;
        $scope.summaryTable.actual_labor = 0;
        $scope.summaryTable.actual_direct_labor = 0;
        $scope.summaryTable.actual_hours_allowed = 0;
        $scope.summaryTable.actual_materials = 0;
        $scope.summaryTable.actual_equipment = 0;
        $scope.summaryTable.diff_total = 0;
        $scope.summaryTable.diff_labor = 0;
        $scope.summaryTable.diff_direct_labor = 0;
        $scope.summaryTable.diff_hours_allowed = 0;
        $scope.summaryTable.diff_materials = 0;
        $scope.summaryTable.diff_equipment = 0;

        var phases = [];
        var lots = [];

        //this is going to die a horrible death when more than one trade
        if($scope.selectedPhase.name !== 'All')
          phases = $filter('filter')($scope.spreadsheets.phases, {'name': $scope.selectedPhase.name}, true);
        else
          phases = $scope.spreadsheets.phases;

        phases.forEach(function(item) {
            if($scope.selectedLot.name !== 'All')
              lots = $filter('filter')(item.lots, {'name': $scope.selectedLot.name}, true);
            else
              lots = item.lots;

            lots.forEach(function(lot) {
                lot.data.forEach(function(task) {
                    //lot.completed says that the task is completed
                    if(task.completed) {
                        $scope.summaryTable.bid_hours_allowed += task.hours_allowed;
                        $scope.summaryTable.bid_direct_labor += task.labor_cost;
                        $scope.summaryTable.actual_hours_allowed += task.actual_man_hours;
                        $scope.summaryTable.actual_direct_labor += task.actual_labor_costs;

                        $scope.summaryTable.bid_labor += task.labor_cost;

                        //compute actual side labor cost
                        var workers_comp = 0;
                        if(task.actual_labor_costs/task.actual_man_hours < $scope.companyFactors.w_comp_break)
                          workers_comp = task.actual_labor_costs * $scope.companyFactors.w_comp_high;
                        else
                          workers_comp = task.actual_labor_costs * $scope.companyFactors.w_comp_low;
                        var taxes = task.actual_labor_costs * $scope.companyFactors.payroll_taxes;

                        $scope.summaryTable.actual_labor += 
                                    task.actual_labor_costs + workers_comp + taxes;

                        $scope.summaryTable.diff_direct_labor += task.saved_labor_costs;
                        $scope.summaryTable.diff_hours_allowed += task.saved_man_hours
                    }

                    task.materials.forEach(function(material) {
                        if(material.submitted) {
                            var sub_tot = material.bid_quantity * material.price_per_order;
                            $scope.summaryTable.bid_materials += sub_tot + 
                                (sub_tot * $scope.companyFactors.sales_tax) + 
                                (material.delivery_price * material.quantity);

                            $scope.summaryTable.actual_materials += material.total;
                        }
                    });

                    task.equipment.forEach(function(equipment) {
                        if(equipment.submitted) {
                            var sub_tot = equipment.bid_quantity * equipment.price_per_order;
                            $scope.summaryTable.bid_equipment += sub_tot + 
                                (sub_tot * $scope.companyFactors.equipment_tax) + 
                                (equipment.delivery_price * equipment.quantity);

                            $scope.summaryTable.actual_equipment += equipment.total;
                        }
                    });
                });
            });
        });

        $scope.summaryTable.diff_materials = $scope.summaryTable.bid_materials -
                $scope.summaryTable.actual_materials;
        $scope.summaryTable.diff_equipment = $scope.summaryTable.bid_equipment -
                $scope.summaryTable.actual_equipment;
        
        $scope.summaryTable.bid_total = $scope.summaryTable.bid_equipment +
                $scope.summaryTable.bid_materials + $scope.summaryTable.bid_labor;

        $scope.summaryTable.actual_total = $scope.summaryTable.actual_equipment +
                $scope.summaryTable.actual_materials + $scope.summaryTable.actual_labor;

        $scope.summaryTable.diff_total = $scope.summaryTable.bid_total - $scope.summaryTable.actual_total;
        $scope.summaryTable.diff_labor = $scope.summaryTable.bid_labor - $scope.summaryTable.actual_labor;

        $scope.summaryTable.diff_labor_percentage = 
                ($scope.summaryTable.bid_labor / $scope.summaryTable.bid_total) -
                ($scope.summaryTable.actual_labor / $scope.summaryTable.actual_total);
        $scope.summaryTable.diff_direct_labor_percentage = 
                ($scope.summaryTable.bid_direct_labor / $scope.summaryTable.bid_total) -
                ($scope.summaryTable.actual_direct_labor / $scope.summaryTable.actual_total);
        $scope.summaryTable.diff_hours_percentage =
                ($scope.summaryTable.bid_direct_labor / $scope.summaryTable.bid_hours_allowed) -
                ($scope.summaryTable.actual_direct_labor / $scope.summaryTable.bid_hours_allowed);
        $scope.summaryTable.diff_materials_percentage = 
                ($scope.summaryTable.bid_materials / $scope.summaryTable.bid_total) -
                ($scope.summaryTable.actual_materials / $scope.summaryTable.actual_total);
        $scope.summaryTable.diff_equipment_percentage = 
                ($scope.summaryTable.bid_equipment / $scope.summaryTable.bid_total) -
                ($scope.summaryTable.actual_equipment / $scope.summaryTable.actual_total);
    };

    $scope.buildLineChart = function() {
        $scope.line_chart_labels = [];
        $scope.line_chart_data = [];
        var bid_data = [];
        var actual_data = [];
        var task_data = [];
        $scope.codes = [];
        var total_hours = 0;
        var total_bids = 0;

        if(!$scope.selectedPhase || !$scope.selectedItem) {
            $scope.line_chart_labels = ['Invalid Project'];
            $scope.line_chart_data = [ [0] , [0] ];

            return;
        }

        var my_bids = $filter('filter')($scope.bid_tasks, {'trade': $scope.selectedTrade.name});
        var my_tasks = [];

        if($scope.selectedPhase.name === 'All') {
            my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name});
        } else {
            my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name, 'phase': $scope.selectedPhase.name});
        }

        if($scope.selectedLot.name !== 'All') {
            my_tasks = $filter('filter')(my_tasks, {'lot': $scope.selectedLot.name});
        }

        my_tasks = $filter('orderBy')(my_tasks, ['start_date'], false);

        my_tasks.forEach(function(task) {
            var in_var = $filter('filter')($scope.codes, {'name': task.task_code}, true);
            
            if(in_var.length === 0) {
                $scope.codes.push({
                    name: task.task_code,
                    task_name: task.task_name
                });
            }
        });

        if($scope.selectedGraph === 'Labor Hours') {
            $scope.line_chart_series = ['Bid Hours', 'Actual Hours'];
            $scope.codes.forEach(function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                tmp.forEach(function(add) {
                    var bid = $filter('filter')(my_bids, {'task_code': code.name, 'plan_code': add.plan_code}, true);
                    if(bid.length !== 1) {
                        //alert('There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }
                    total_bids += bid[0].totals.hours_allowed;
                    total_hours += add.actual_man_hours;
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        } else if ($scope.selectedGraph === 'Labor Costs') {
            $scope.line_chart_series = ['Bid Labor Costs', 'Actual Labor Costs'];
            $scope.codes.forEach(function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                tmp.forEach(function(add) {
                    var bid = $filter('filter')(my_bids, {'task_code': code.name, 'plan_code': add.plan_code}, true);
                    if(bid.length !== 1) {
                        //alert('There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }
                    total_bids += bid[0].totals.labor;
                    total_hours += add.actual_labor_costs;
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        } else if ($scope.selectedGraph === 'Total Costs') {
            $scope.line_chart_series = ['Bid Total Costs', 'Actual Total Costs'];
            $scope.codes.forEach(function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                tmp.forEach(function(add) {
                    if(!add.actual_equipment_costs) add.actual_equipment_costs = 0;
                    var bid = $filter('filter')(my_bids, {'task_code': code.name, 'plan_code': add.plan_code}, true);
                    if(bid.length !== 1) {
                        //alert('There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }
                    total_bids += (bid[0].totals.labor + bid[0].totals.materials + bid[0].totals.equipment);
                    total_hours += (add.actual_labor_costs + add.actual_material_costs + add.actual_equipment_costs);
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        } else if ($scope.selectedGraph === 'Equipment') {
            $scope.line_chart_series = ['Bid Equipment Costs', 'Actual Equipment Costs'];
            $scope.codes.forEach(function(code) {
                $scope.line_chart_labels.push(code.name);

                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                tmp.forEach(function(add) {
                    if(!add.actual_equipment_costs) add.actual_equipment_costs = 0;
                    var bid = $filter('filter')(my_bids, {'task_code': code.name, 'plan_code': add.plan_code}, true);
                    if(bid.length !== 1) {
                        //alert('There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }
                    total_bids += bid[0].totals.equipment;
                    total_hours += add.actual_equipment_costs;
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        } else {
            $scope.line_chart_series = ['Bid Material Costs', 'Actual Material Costs'];
            $scope.codes.forEach(function(code) {
                $scope.line_chart_labels.push(code.name);
                
                if($scope.selectedDataType !== 'Cumulative'){
                    total_bids = 0;
                    total_hours = 0;
                }

                var tmp = $filter('filter')(my_tasks, {'task_code': code.name});
                tmp.forEach(function(add) {
                    var bid = $filter('filter')(my_bids, {'task_code': code.name, 'plan_code': add.plan_code}, true);
                    if(bid.length !== 1) {
                        //alert('There was a problem getting the bid for the task.  Contact Admin');
                        return;
                    }
                    total_bids += bid[0].totals.materials;
                    total_hours += add.actual_material_costs;
                });

                bid_data.push(total_bids.toFixed(2));
                actual_data.push(total_hours.toFixed(2));
            });

            $scope.line_chart_data.push(bid_data);
            $scope.line_chart_data.push(actual_data);
        }
    };

    $scope.buildDoughnutChart = function() {
        var total_hours_allowed = 0;
        var completed_hours = 0;
        var not_completed_hours = 0;
        var delayed_hours = 0;

        var my_tasks = [];

        if($scope.selectedPhase.name === 'All') {
            my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name});
        } else {
            my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.selectedTrade.name, 'phase': $scope.selectedPhase.name});
        }

        if($scope.selectedLot.name !== 'All') {
            my_tasks = $filter('filter')(my_tasks, {'lot': $scope.selectedLot.name});
        }

        my_tasks.forEach(function(task) {
            var bid = $filter('filter')($scope.bid_tasks, {'task_name': task.task_name, 'plan_code': task.plan_code}, true);

            for(var i=0; i<bid.length; i=i+1) {
                total_hours_allowed += bid[i].totals.hours_allowed;
                if(task.status === 'finished') {
                    completed_hours += bid[i].totals.hours_allowed;
                } else if(task.status === 'on_track'){
                    not_completed_hours += bid[i].totals.hours_allowed;
                } else {
                    delayed_hours += bid[i].totals.hours_allowed;
                }
            } 
        });

        total_hours_allowed = total_hours_allowed.toFixed(2);
        completed_hours = completed_hours.toFixed(2);
        not_completed_hours = not_completed_hours.toFixed(2);
        delayed_hours = delayed_hours.toFixed(2);

        $scope.bid_hours_data = [total_hours_allowed, not_completed_hours, delayed_hours, completed_hours, 0];
    };

    $scope.phaseFilter = function(selected) {
    	if(!selected) return;

    	if(selected.name === 'All') {
    		return function() { 
    			return true;
    		};
    	} else {
    		return function(selectedPhase) {
	    		return selectedPhase.name === selected.name;
	    	};
    	}
    };

    $scope.lotFilter = function(selected) {
        if(!selected) return;

        if(selected.name === 'All') {
            return function() { 
                return true;
            };
        } else {
            return function(selectedLot) {
                return selectedLot.name === selected.name;
            };
        }
    };

    $scope.changePhase = function() {
    	if(!$scope.selectedPhase) return;

        $scope.lots = [];

        if($scope.selectedPhase.name === 'All') {
            var my_tasks = $scope.tasks; //$filter('filter')($scope.tasks, {'trade': $scope.user.trade[0]});
        } else {
            var my_tasks = $filter('filter')($scope.tasks, {'phase': $scope.selectedPhase.name});
        }

        my_tasks.forEach(function(task) {
            var in_lot = $filter('filter')($scope.lots, { 'name': task.lot});

            if(in_lot.length === 0) {
                $scope.lots.push({
                    name: task.lot
                });
            }
        });

        $scope.lots = $filter('orderBy')($scope.lots, ['name'], false);

        $scope.lots.unshift({
            name: 'All'
        });

        $scope.selectedLot = $scope.lots[0];

        $scope.buildDoughnutChart();
        $scope.buildLineChart();
        $scope.buildSummaryTable();
    };

    $scope.changeLot = function() {
        if(!$scope.selectedLot) return;

        if($scope.selectedLot.name === 'All') {
            var my_tasks = $scope.tasks; //$filter('filter')($scope.tasks, {'trade': $scope.user.trade[0]});
        } else {
            var my_tasks = $filter('filter')($scope.tasks, {'lot': $scope.selectedLot.name});
        }

        $scope.buildDoughnutChart();
        $scope.buildLineChart();
        $scope.buildSummaryTable();
    };

    $scope.changeBuilder = function() {
    	if(!$scope.selectedBuilder) return;
    	$scope.projects = [];
		$scope.tasks = [];
		$scope.phases = [];
		$scope.bid_tasks = [];
		$scope.bid_hours_data = [0,0,0,0,1];

        userService.getMainAccount($scope.user.username).then(function(user) {
            var match_string = '{ "trades.main_username": ' + user.username + '}';
            Projects.query({
                'company_code': $scope.selectedBuilder.company_code, 
                'trade_code': $scope.selectedBuilder.trade_code, 
                'manager': MeanUser.user.username,
                'complete': false,
                'match_string_for_manager': true,
                'username': user.username }
                , function(projects) {
                $scope.projects = projects;
            });
        });
    };

    $scope.buildSpreadsheet = function() {
    	$scope.spreadsheets = [];
	    $scope.spreadsheets.phases = [];
	    $scope.spreadsheets.phases.lots = [];

    	var my_tasks = $filter('filter')($scope.tasks, {'trade': $scope.user.trade[0]}, true);
    	var phase_tasks = [];
    	var lot_tasks = [];
    	var ordered_tasks = [];
    	var temp_tasks = [];
    	var lot_numbers = [];
    	var lot_data = [];

    	$scope.phases.forEach(function(phase) {
    		if(phase.name !== 'All') {
    			//get all of my tasks by the current phase
    			phase_tasks = $filter('filter')(my_tasks, {'phase': phase.name}, true);

    			lot_numbers = [];
    			//build a lot list
    			phase_tasks.forEach(function(task) {
	    			var in_var = $filter('filter')(lot_numbers, {'name': task.lot}, true);
	    			temp_tasks = [];

	    			if(in_var.length === 0) {
	    				lot_numbers.push({
	    					name: task.lot
	    				});
	    			}
	    		});

	    		lot_numbers = $filter('orderBy')(lot_numbers, ['name'], false);

    			lot_numbers.forEach(function(lot_number) {
    				lot_data = [];
    				var total_hours_allowed = 0;
    				var total_labor_costs = 0;
    				var actual_man_hours = 0;
    				var actual_labor_costs = 0;
    				var total_hours_saved = 0;
    				var total_labor_saved = 0;

    				lot_tasks = $filter('filter')(phase_tasks, {'lot': lot_number.name}, true);
    				ordered_tasks = $filter('orderBy')(lot_tasks, ['job_code'], false);

    				ordered_tasks.forEach(function(task) {
	    				var bid = $filter('filter')($scope.bid_tasks, {'task_name': task.task_name, 'plan_code': task.plan_code}, true);
						if(bid.length === 0) {
							var new_bid = {
								totals: {
									hours_allowed: 0,
									labor_cost: 0
								}
							}

							bid.push(new_bid);

						} else if(bid.length > 1) {
                            alert('Getting too many bids back for task code ' + task.task_code);
						}

			    		var code = task.task_code + ' - ' + task.task_name;

			    		var hours_saved = 0;
			    		var labor_saved = 0;

			    		total_hours_allowed += bid[0].totals.hours_allowed;
			    		total_labor_costs += bid[0].totals.labor;
			    		actual_man_hours += task.actual_man_hours;
			    		actual_labor_costs += task.actual_labor_costs;
			    		hours_saved = bid[0].totals.hours_allowed - task.actual_man_hours;
			    		labor_saved = bid[0].totals.labor - task.actual_labor_costs;
			    		total_hours_saved += hours_saved;
			    		total_labor_saved += labor_saved;

                        var task_completed = (task.date_completed)?true:false;
                        
                        var start_date = moment(task.start_date);
                        var days = 0;
                        var warning_level = 0;

                        if(task_completed){
                            days = Math.round(moment.duration(moment(task.date_completed) - start_date).asDays());
                        } else {
                            days = Math.round(moment.duration(moment() - start_date).asDays());
                        }
                        if(days === 1)
                            warning_level = 1;
                        else if(days > 1)
                            warning_level = 2;

                        //compute actual side labor cost
                        var workers_comp = 0;
                        if(task.actual_labor_costs/task.actual_man_hours < $scope.companyFactors.w_comp_break)
                          workers_comp = task.actual_labor_costs * $scope.companyFactors.w_comp_high;
                        else
                          workers_comp = task.actual_labor_costs * $scope.companyFactors.w_comp_low;
                        var taxes = task.actual_labor_costs * $scope.companyFactors.payroll_taxes;

                        var actual_material = 0;
                        var actual_equipment = 0;

                        if(task.materials) {
                            task.materials.forEach(function(add) {
                                actual_material += add.total;
                            });
                        }

                        if(task.equipment) {
                            task.equipment.forEach(function(add) {
                                actual_equipment += add.total;
                            });
                        }

                        actual_labor_costs += workers_comp + taxes;

			    		lot_data.push({
		    				lot: task.lot,
                            code: code,
                            hours_allowed: bid[0].totals.hours_allowed,
                            labor_cost: bid[0].totals.labor,
                            bid_materials_cost: bid[0].totals.materials,
                            bid_equipment_cost: bid[0].totals.equipment,
                            warning_level: warning_level,
                            scheduled_date: new Date(task.start_date),
                            actual_man_hours: task.actual_man_hours,
                            actual_labor_costs: task.actual_labor_costs + workers_comp + taxes,
                            actual_material_costs: actual_material,
                            actual_equipment_costs: actual_equipment,
                            saved_man_hours: hours_saved,
                            saved_labor_costs: labor_saved,
                            notes: task.notes,
                            completed: task_completed,
                            date_completed: new Date(task.date_completed),
                            tooltip_hours: task.tooltip,
                            bid_materials: bid[0].materials,
                            bid_equipment: bid[0].equipment,
                            materials: task.materials,
                            equipment: task.equipment
			    		});
	    			});

					temp_tasks.push({
						name: lot_number.name,
						data: lot_data,
						total_hours_allowed: total_hours_allowed,
	    				total_labor_costs: total_labor_costs,
	    				actual_man_hours: actual_man_hours,
	    				actual_labor_costs: actual_labor_costs,
	    				total_hours_saved: total_hours_saved,
	    				total_labor_saved: total_labor_saved
					});
    			});

				$scope.spreadsheets.phases.push({
		    		name: phase.name,
		    		lots: temp_tasks
		    	});
    		}
    	});

        $scope.buildSummaryTable();

		console.log('finished task build' + $scope.spreadsheets);
    };

    $scope.changeProject = function() {
    	if(!$scope.selectedItem) return;

        $scope.buildTasks($scope.selectedItem);
    };

    $scope.buildTasks = function(project) {
        $scope.phases = [];
        $scope.lots = [];

        ProjectHours.query({'project_id': project._id, 'trade': $scope.user.trade[0]}, function(project_hours) {
            ProjectMaterials.query({'project_id': project._id, 'trade': $scope.user.trade[0]}, function(project_materials) {
                ProjectEquipments.query({'project_id': project._id, 'trade': $scope.user.trade[0]}, function(project_equipment) {
                    ProjectTasks.query({'project_id': project._id, 'trade': $scope.user.trade[0]}, function (tasks) {
                        $scope.tasks = tasks;

                        tasks.forEach(function(task) {
                            var task_hours = $filter('filter')(project_hours, {'project_task_id': task._id}, true);
                            var in_var = $filter('filter')($scope.phases, { 'name': task.phase}, true);
                            var in_lot = $filter('filter')($scope.lots, { 'name': task.lot}, true);

                            var task_materials = $filter('filter')(project_materials, 
                                        { 'phase': task.phase , 'task_code': task.task_code}, true);
                            var task_equipment = $filter('filter')(project_equipment, 
                                        { 'phase': task.phase , 'task_code': task.task_code}, true);

                            task.materials = [];
                            task.equipment = [];

                            task.actual_material_costs = 0;
                            task.actual_equipment_costs = 0;

                            task_materials.forEach(function(material) {
                                var mat = $filter('filter')(material.materials, {'lot': task.lot}, true);

                                mat.forEach(function(curr_mat) {
                                   task.actual_material_costs += curr_mat.total;
                                   curr_mat.submitted = material.submitted;
                                   task.materials.push(angular.copy(curr_mat));
                                });
                            });

                            task_equipment.forEach(function(equipment) {
                                var eq = $filter('filter')(equipment.equipment, {'lot': task.lot}, true);

                                eq.forEach(function(curr_eq) {
                                   task.actual_equipment_costs += curr_eq.total;
                                   curr_eq.submitted = equipment.submitted;
                                   task.equipment.push(angular.copy(curr_eq));
                                });
                            });

                            task.actual_man_hours = 0;
                            task.actual_labor_costs = 0;

                            task.tooltip = [];
                            task_hours.forEach(function(hours) {
                                task.actual_man_hours += hours.hours;
                                task.actual_labor_costs += hours.pay_total;
                                task.tooltip.push({
                                    name: hours.name,
                                    username: hours.username,
                                    rate: hours.rate,
                                    hours: hours.hours,
                                    pay_total: hours.pay_total,
                                    date: new Date(hours.date)
                                });
                            });

                            if(in_lot.length === 0) {
                                $scope.lots.push({
                                    name: task.lot
                                });
                            }

                            if(in_var.length === 0) {
                                $scope.phases.push({
                                    name: task.phase
                                });
                            }
                        });

                        $scope.phases = $filter('orderBy')($scope.phases, ['name'], false);
                        $scope.lots = $filter('orderBy')($scope.lots, ['name'], false);

                        $scope.phases.unshift({
                            name: 'All'
                        });

                        $scope.lots.unshift({
                            name: 'All'
                        });

                        $scope.selectedPhase = $scope.phases[0];
                        $scope.selectedLot = $scope.lots[0];

                        ProjectBids.query({'project_id': project._id, 
                            'trade': $scope.user.trade[0], 'latest': true}, function(bid_tasks) {
                            $scope.bid_tasks = bid_tasks;

                            $scope.buildDoughnutChart();
                            $scope.buildSpreadsheet();
                            $scope.buildLineChart();
                        });
                    });
                });
            });
        });
    };

    $scope.init = function() {
    	if(!MeanUser.user.username) return;

    	$scope.bid_hours_data = [0,0,0,0,1];

        userService.getMainAccountId($scope.user.username).then(function(id) {
            contactService.getMyContacts(id).then(function(contacts) {
                $scope.builders = [];

                Trades.query({'main_account_id': id}, function(trade) {
                    $scope.companyFactors = trade[0].costs;
                    trade[0].company_code = 
                        aceUtils.padDigits(trade[0].company_code, 3);
                    trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                    $scope.builders.push(trade[0]);
                });

                contacts.builders.forEach(function(builder) {
                    Builders.query({'builder': builder._id}, function(builders) {
                        builders[0].company_code = 
                            aceUtils.padDigits(builders[0].company_code, 3);
                        builders[0].trade_code = '00';
                        $scope.builders.push(builders[0]);
                    });
                });

                $scope.selectedTrade = {};
                $scope.selectedTrade.name = $scope.user.trade[0];
            });
        });
	};
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectTradeManager.js